import React from "react";
import { Table } from "antd";

import SimpleModals from "../../common/simpleModal";

function maxPropObject(arr) {
  if (!Array.isArray(arr) || arr.length === 0) return null;

  return arr.reduce((maxObj, currentObj) => {
    return Object.keys(currentObj).length > Object.keys(maxObj).length
      ? currentObj
      : maxObj;
  }, arr[0]);
}


const PreviewSheetModal = ({ openModal, setOpenModal, modalData }) => {
  console.log("FINAL MODALDATA-----------------");
  console.log(maxPropObject(modalData));
  const columns =
    modalData.length > 0
      ? Object.keys(maxPropObject(modalData)).map((key) => ({
          title: key,
          dataIndex: key,
          render: (text) => {
                      console.log(`Title: ${key}, Text: ${text}`);
          return (
            <div
              style={{
                maxWidth: "200px",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              {text}
            </div>
          );
        },
          width: "30%",
        }))
      : [];

  return (
    <SimpleModals
      title="Preview Excel Sheet"
      open={openModal}
      setOpen={setOpenModal}
      footer={false}
      width={1200}
    >
      <Table
      style={{padding:'2rem 0'}}
        columns={columns}
        dataSource={modalData}
        scroll={{ x: 500 }}
        pagination={false}
        bordered
        size="small"
      />
    </SimpleModals>
  );
};

export default PreviewSheetModal;
